import React, { useEffect, useContext, useState, useRef } from "react";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

import AuthService from "../../../services/User/AuthService";
import CompanyService from "../../../services/User/CompanyService";
import LoadingContext from "../../../store/loading-context";
import HttpError from "../../../utill/HttpError";
import LoginOtpDialog from "./LoginOtpDialog";
//import LoginOtpDialog from "./LoginOtpDialog";

// import "./Login.module.css";

const Login = () => {
  const history = useHistory();

  const loadingCtx = useContext(LoadingContext);

  const [errMsg, setErrMsg] = useState(true);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [token, setToken] = useState(true);
  const [isAgree, setIsAgree] = useState(false);

  const userIdRef = useRef();
  const passwordRef = useRef();

  const loginHandler = async (e) => {
    e.preventDefault();

    const userId = userIdRef.current.value;
    const password = passwordRef.current.value;

    if (!latitude || !longitude) {
      Swal.fire(
        "Opps!",
        "Unable to retrieve your location, please enable location access in your browser",
        "error"
      );
      return;
    }

    if (!isAgree) {
      Swal.fire(
        "Opps!",
        "Please accept to the Terms & Conditions and Privacy Policy",
        "error"
      );
      return;
    }

    if (!userId) {
      Swal.fire("Opps!", "Invalid Mobile ID", "error");
      return;
    }

    if (!password) {
      Swal.fire("Opps!", "Invalid Password", "error");
      return;
    }

    loadingCtx.startLoading();

    try {
      const data = await AuthService.sendOtp(
        userId,
        password,
        latitude,
        latitude
      );

      if (!data) {
        throw new Error("Request Failed!");
      }

      const status = data.status;
      const message = data.message;

      if (status === "SUCCESS" && message !== "LOGIN_SUCCESS") {
        const token = data.data.token;
        setToken(token);
        setErrMsg(message);
        setOpen(true);
      } else if (status === "SUCCESS" && message === "LOGIN_SUCCESS") {
        const accessToken = data.data.access_token;
        const name = data.data.name;
        const user_id = data.data.user_id;
        const user_type = data.data.user_type;
        const mobile = data.data.mobile;
        const email = data.data.email;
        const fpay_outlet_onboarded = data.data.fpay_outlet_onboarded;
        const developer_access = data.data.developer_access;

        localStorage.setItem("timestamp", new Date().getTime());
        localStorage.setItem("access_token", accessToken);
        localStorage.setItem(
          "user",
          JSON.stringify({
            name: name,
            user_type: user_type,
            user_id: user_id,
            mobile: mobile,
            email: email,
            developer_access: developer_access,
          })
        );

        if (fpay_outlet_onboarded == "YES") {
          localStorage.setItem("is_outlet", true);
        } else {
          localStorage.setItem("is_outlet", false);
        }

        //history.push("/user/dashboard");
        window.location.href = "/#/user/dashboard";
        window.location.reload();
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  const getLocation = () => {
    if (!navigator.geolocation) {
      Swal.fire(
        "Opps!",
        "Geolocation is not supported by your browser",
        "error"
      );
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        () => {
          Swal.fire(
            "Opps!",
            "Unable to retrieve your location, please enable location access in your browser",
            "error"
          );
        }
      );
    }
  };

  useEffect(() => {
    getLocation();
    isLoggedIn();
  }, []);

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleIsAgree = (v) => {
    setIsAgree(v);
  };

  // ** AUTO LOGIN ** //
  const isLoggedIn = () => {
    const token = AuthService.getAccessToken();
    if (token) {
      window.location.href = "/#/user/dashboard";
      window.location.reload();
    }
  };
  // ** AUTO LOGIN ** //

  const [isDomain, setIsDomain] = useState("Unknown");
  const [company, setCompany] = useState();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    loadingCtx.startLoading();

    try {
      const responseData = await CompanyService.fetchByDomainName(
        window.location.hostname
      );

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        const data = responseData.data;
        setCompany(data);
        setIsDomain(true);

        localStorage.setItem("company", JSON.stringify(data));

        // TITLE
        document.title = data.title_text;

        // FAVICON
        const favicon = document.getElementById("favicon");
        favicon.href = data.favicon;
      } else {
        setIsDomain(false);
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    flexDirection: "column",
    textAlign: "center",
  };

  const messageStyle = {
    fontWeight: "bold",
    fontSize: "24px", // Increased font size
    textTransform: "uppercase", // All capital letters
  };

  return (
    <React.Fragment>
      {!isDomain && (
        <div style={containerStyle}>
          <p style={messageStyle}>The domain name is not yet whitelisted.</p>
          <p style={messageStyle}>
            Please contact to the administrator for assistance.
          </p>
        </div>
      )}

      {isDomain === true && (
        <div class="login-box">
          <div class="card card-outline card-primary">
            <div class="card-header text-center">
              <div class="h1">
                {company && <img src={company.logo} alt="logo" width="180px" />}

                {/* <h4>
                <strong>{companyName} </strong>
              </h4> */}
              </div>
            </div>
            <div class="card-body">
              <h5 className="text-center">Welcome Back!</h5>
              <p class="login-box-msg">Login to access to your account.</p>
              <form autoComplete="off">
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <span class="fas fa-user"></span>
                    </div>
                  </div>
                  <input
                    type="text"
                    ref={userIdRef}
                    class="form-control"
                    placeholder="Mobile Number"
                  />
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <span class="fas fa-lock"></span>
                    </div>
                  </div>
                  <input
                    type="password"
                    ref={passwordRef}
                    class="form-control"
                    placeholder="Password"
                  />
                </div>

                <div class="row mb-3">
                  <div class="col-12">
                    <div class="icheck-primary">
                      <input
                        type="checkbox"
                        id="remember"
                        onChange={(e) => {
                          //  alert(e.target.checked);
                          handleIsAgree(e.target.checked);
                        }}
                      />
                      <label for="remember" style={{ fontWeight: "normal" }}>
                        I agree to the T&C and Privacy Policy
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <button
                    type="button"
                    onClick={loginHandler}
                    class="btn btn-primary btn-block"
                  >
                    Login
                  </button>
                </div>

                <div class="row mt-2">
                  <div class="col-12 mx-auto">
                    <p class="float-right">
                      <a href="/#/forgot_password">I forgot my password</a>
                    </p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6 mx-auto">
                    <a
                      href={company ? company.android_app : ""}
                      target="_blank"
                    >
                      <img
                        src="assets/img/google-play-icon.png"
                        alt="logo"
                        height="40px"
                      />
                    </a>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-12 mx-auto">
                    <p class="text-center">
                      Don't have an account? <a href="/#/signup">Signup</a>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <LoginOtpDialog
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        errMsg={errMsg}
        token={token}
      />
    </React.Fragment>
  );
};

export default Login;
